// Applies CSP nonce policy to runtime-created style tags.
// Callers keep ownership of where each style tag is inserted.
import { resolveRuntimeStyleNonce } from '@lentystyle/guard/runtime'

// Applies the configured runtime style nonce when policy provides one.
export function applyRuntimeStyleNonce(styleTag: HTMLStyleElement): void {
  const nonce = resolveRuntimeStyleNonce()
  // Leave style tags unchanged when no CSP nonce is configured.
  if (!nonce) {
    return
  } else {
    // Keep reused style tags aligned with the latest runtime policy.
    styleTag.nonce = nonce
  }
}
